export const MAX_WEBSITE_LENGTH = 250;
